import { connect } from 'react-redux';
import Search from './Search';
import { showToast } from '../../../redux/actions/toasts';

const mapDispatchToProps = (dispatch) => ({
  showToast: (payload) => dispatch(showToast(payload)),
});

export default connect(undefined, mapDispatchToProps)(Search);
